import { Controller } from '@hotwired/stimulus'

export default class IbanChannelController extends Controller {
  static targets = ["ibanLink", "spinner"]
  static values = {
    id: Number
  }

  connect() {
    this.subscription = App.cable.subscriptions.create(
      {
        channel: "Users::Profiles::IbanChannel",
        profile_id: this.idValue
      },
      {
        received: this._received.bind(this),
      }
    )
  }

  disconnect() {
    if (this.subscription) {
      App.cable.subscriptions.remove(this.subscription)
    }
  }

  _received(data) {
    if (data.status === "success" && data.link !== undefined) {
      this.ibanLinkTarget.innerHTML = data.link
      this.spinnerTarget.classList.add("d-none")
    }
  }

  displaySpinner() {
    this.spinnerTarget.classList.remove("d-none")
  }
}
